/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { markdown } from 'markdown';
import { MarkdownProps } from './types';
import { classnames } from 'helpers/utils/classnames';
import { sanitize } from 'helpers/utils/htmlSanitize';

const Markdown = ({ children, className }: MarkdownProps) => {
  const html = markdown.toHTML(children ?? '');

  const dangerousHtml = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

  // sanitize-html is pure JS (no DOM), so this sanitizes on the server too and renders in SSR HTML.
  const sanitizedHtml = sanitize(dangerousHtml);

  return (
    <p className={classnames('whitespace-pre-wrap', className)} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

export default Markdown;